import { useState, useCallback, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { RequestModal } from "@/components/site/RequestModal";
import { CookieConsent } from "@/components/site/CookieConsent";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ServicePricing from "@/pages/ServicePricing";
import Legal from "@/pages/Legal";
import { TERMS_DOC, PRIVACY_DOC } from "@/data/legal";

function App() {
  const [modal, setModal] = useState({ open: false, service: "", price: "", meta: null });
  const [theme, setTheme] = useState(() => localStorage.getItem("rs-theme") || "dark");

  useEffect(() => {
    localStorage.setItem("rs-theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    [],
  );

  const selectPrice = useCallback((service, price, meta) => {
    setModal({ open: true, service, price, meta: meta || null });
  }, []);

  const rootStyle = {
    backgroundColor: theme === "dark" ? "#050505" : "#fbf8f1",
    backgroundImage:
      theme === "dark"
        ? "radial-gradient(130% 90% at 50% -20%, #100d09 0%, #070605 40%, #050505 100%)"
        : "linear-gradient(rgba(255,253,247,0.5), rgba(255,251,243,0.62)), url(/bg-light-marble.jpg)",
  };

  return (
    <div className={`rs-root font-body antialiased theme-${theme}`} style={rootStyle}>
      <Header theme={theme} onToggleTheme={toggleTheme} />
      <main>
        <Routes>
          <Route path="/" element={<Home theme={theme} />} />
          <Route path="/priser/:serviceId" element={<ServicePricing onSelectPrice={selectPrice} />} />
          <Route path="/handelsbetingelser" element={<Legal doc={TERMS_DOC} />} />
          <Route path="/privatlivspolitik" element={<Legal doc={PRIVACY_DOC} />} />
        </Routes>
      </main>
      <Footer theme={theme} />

      <RequestModal
        open={modal.open}
        onOpenChange={(open) => setModal((m) => ({ ...m, open }))}
        service={modal.service}
        price={modal.price}
        meta={modal.meta}
      />
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
